import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import './confirmation.css';
import '../footer/about.css';
import contiImage from '../imagesHome/conti.png';

const ConfirmationPage = () => {
  const navigate = useNavigate();

  const goToLogin = () => {
    navigate('/emailconnect');
  };

  return (
    <div className='general-container-footer-info-ab'>
      <div className='info-footer-container-ab'>
       

        <div className='confirmation-wrapper'>
          <div className="confirmation-page">
            

            <div className='success-icon-container'>
             
              <img src={contiImage} alt='Conti mascot' className='confirmation-conti' />
            </div>

            <h2>Cont confirmat cu succes!</h2>
            <p className='confirmation-message'>
              Felicitari! Adresa ta de email a fost verificata cu succes.
            </p>
            <p className='confirmation-submessage'>
              Acum te poti autentifica si incepe calatoria de invatare in lumea contabilitatii cu lectii,
              aplicatii si quiz-uri interactive.
            </p>

          

            <button onClick={goToLogin} className='btn-confirmation-primary'>
              <span>Autentificare</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationPage;
